/**
 * Patient Artifacts feature auto-registration and exports.
 *
 * Importing this module registers the feature with the dynamic-features
 * registry; everything in `./store` and `./components` is then available
 * via the public surface.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { patientArtifactsFeature } from './store/feature';

autoRegisterFeature(patientArtifactsFeature);

export * from './components';
export { PatientTimelineTestPage } from './PatientTimelineTestPage';
export * from './store';
export * from './types';
